/** @format */

/* eslint-disable */
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import BreadCrumb from '../../../../../Components/BreadCrumb/Index'
import EnumsServerCombo from '../../../../../Components/ComboBox/EnumsServerCombo'
import DatePicker from '../../../../../Components/Date/DatePicker'
import Loader from '../../../../../Components/Loaders/Loader'
import FIleSelectLookup from '../../../../../Components/Lookup/FIleSelectLookup'
import GroupedTable from '../../../../../Components/Tables/GroupedTable'
import Pager from '../../../../../Components/Tables/Pager'
import localize from '../../../../../Global/Localize'
import { toBase64 } from '../../../../../Helpers/blobs'
import { formatCurrency, formatDate } from '../../../../../Helpers/formatters'
import { getData, putData } from '../../../../../Helpers/webApi'
import ViewBankToBankDataModal from '../ViewBankToBankDataModal'
import ReconcileBankToBankDataModal from './ReconcileBankToBankDataModal'
import ViewAuditLogs from '../../../../../Components/ReUsables/ViewAuditLogs/ViewAuditLogs'
import RecordsPerPage from '../../../../../Components/RecordsPerPage/RecordsPerPage'

function Reconciliation() {
  const columns = [
    {
      label: localize('createdDate'),
      template: r => <>{formatDate(r?.createdDate)}</>,
    },
    {
      label: localize('serialNumber'),
      template: r => <>{r?.paddedSerialNumber}</>,
      sortBy: 'paddedSerialNumber',
    },
    {
      label: localize('status'),
      template: r => <>{r?.statusDescription}</>,
      sortBy: 'statusDescription',
    },
    {
      label: localize('recordStatus'),
      template: r => <>{r?.recordStatusDescription}</>,
      sortBy: 'recordStatusDescription',
    },
    {
      label: localize('chartOfAccountName'),
      template: r => <>{r?.chartOfAccountName}</>,
      sortBy: 'chartOfAccountName',
    },
    {
      label: localize('chartOfAccountCostDistributionRule'),
      template: r => <>{r?.chartOfAccountCostDistributionRuleDescription}</>,
      sortBy: 'chartOfAccountCostDistributionRuleDescription',
    },
    {
      label: localize('paymentAmount'),
      template: r => <>{formatCurrency(r?.paymentAmount)}</>,
      sortBy: 'paymentAmount',
    },
    {
      label: localize('totalAmount'),
      template: r => <>{formatCurrency(r?.totalAmount)}</>,
      sortBy: 'totalAmount',
    },
    {
      label: localize('transactionReferenceCode'),
      template: r => <>{r?.transactionReferenceCode}</>,
      sortBy: 'transactionReferenceCode',
    },
    {
      label: localize('documentReferenceNumber'),
      template: r => <>{r?.documentReferenceNumber}</>,
      sortBy: 'documentReferenceNumber',
    },
    {
      label: localize('currency'),
      template: r => <>{r?.currency}</>,
      sortBy: 'currency',
    },
    {
      label: localize('bankCode'),
      template: r => <>{r?.bankCode}</>,
      sortBy: 'bankCode',
    },
    {
      label: localize('branchCode'),
      template: r => <>{r?.branchCode}</>,
      sortBy: 'branchCode',
    },
    {
      label: localize('paymentDate'),
      template: r => <>{formatDate(r?.paymentDate, false)}</>,
      sortBy: 'paymentDate',
    },
    {
      label: localize('paymentReferenceCode'),
      template: r => <>{r?.paymentReferenceCode}</>,
      sortBy: 'paymentReferenceCode',
    },
    {
      label: localize('paymentCode'),
      template: r => <>{r?.paymentCode}</>,
      sortBy: 'paymentCode',
    },
    {
      label: localize('paymentMode'),
      template: r => <>{r?.paymentMode}</>,
      sortBy: 'paymentMode',
    },
    {
      label: localize('additionalInfo'),
      template: r => <>{r?.additionalInfo}</>,
      sortBy: 'additionalInfo',
    },
    {
      label: localize('accountNumber'),
      template: r => <>{r?.accountNumber}</>,
      sortBy: 'accountNumber',
    },
    {
      label: localize('accountName'),
      template: r => <>{r?.accountName}</>,
      sortBy: 'accountName',
    },
    {
      label: localize('institutionCode'),
      template: r => <>{r?.institutionCode}</>,
      sortBy: 'institutionCode',
    },
    {
      label: localize('institutionName'),
      template: r => <>{r?.institutionName}</>,
      sortBy: 'institutionName',
    },
    {
      label: localize('exceptionMessage'),
      template: r => <>{r?.exceptionMessage}</>,
      sortBy: 'exceptionMessage',
    },
    {
      label: localize('valueDate'),
      template: r => <>{formatDate(r?.valueDate, true)}</>,
      sortBy: 'valueDate',
    },
    {
      label: localize('verifiedBy'),
      template: r => <>{r?.auditedBy}</>,
      sortBy: 'auditedBy',
    },
    {
      label: localize('verifiedDate'),
      template: r => <>{formatDate(r?.auditedDate, true)}</>,
      sortBy: 'auditedDate',
    },
    {
      label: localize('modifiedBy'),
      template: r => <>{r?.modifiedBy}</>,
      sortBy: 'modifiedBy',
    },
    {
      label: localize('modifiedDate'),
      template: r => <>{formatDate(r?.modifiedDate, true)}</>,
      sortBy: 'modifiedDate',
    },
    {
      label: localize('createdBy'),
      template: r => <>{r?.createdBy}</>,
      sortBy: 'createdBy',
    },
  ]

  const [isBusy, setIsBusy] = useState(false)
  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [reqParams, setReqParams] = useState({
    status: 0,
    startDate: null,
    endDate: null,
    filterText: '',
    bankToBankRequestFilter: 0,
    pageIndex: 0,
    pageSize: 10,
    dateRequestsFilter: 15,
    customDate: false,
  })

  const [groupBy, setGroupBy] = useState({
    label: localize('status'),
    column: 'statusDescription',
  })
  const [mode, setMode] = useState(null)
  const [selectedBankToBankRequest, setSelectedBankToBankRequest] = useState()
  const [refreshAt, setRefreshAt] = useState(false)
  const [auditLogsDetails, setAuditLogsDetails] = useState({})

  useEffect(() => {
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reqParams.pageIndex, reqParams.pageSize, refreshAt])

  async function loadData() {
    setIsBusy(true)
    const { success, data } = await getData(
      '/BankToBankRequest/find-bank-to-bank-requests-by-status-and-filter-in-page',
      reqParams,
      false
    )
    if (success) {
      setData(data)
    }

    setIsBusy(false)
  }
  const groupingColumns = [
    {
      label: localize('verifiedBy'),
      column: 'auditedBy',
    },
    {
      label: localize('bankCode'),
      column: 'bankCode',
    },
    {
      label: localize('branchCode'),
      column: 'kycInbranchCodefo',
    },
    {
      label: localize('chartOfAccountName'),
      column: 'chartOfAccountName',
    },
    {
      label: localize('documentReferenceNumber'),
      column: 'documentReferenceNumber',
    },
    {
      label: localize('modifiedBy'),
      column: 'modifiedBy',
    },
    {
      label: localize('paymentAmount'),
      column: 'paymentAmount',
    },
    {
      label: localize('recordStatus'),
      column: 'recordStatusDescription',
    },

    {
      label: localize('status'),
      column: 'statusDescription',
    },
    {
      label: localize('transactionReferenceCode'),
      column: 'transactionReferenceCode',
    },
  ]
  async function handleSubmit() {
    setIsBusy(true)
    const { success } = await putData(
      '/BankToBankRequest/parse-bank-to-bank-requests-import',
      selectedBankToBankRequest,
      false,
      'Operation Completed Successfully'
    )
    if (success) {
      setRefreshAt(true)
    }
    setIsBusy(false)
  }

  const handleViewAuditLogs = item => {
    setAuditLogsDetails(item)
    setMode('auditLogs')
  }

  const handleCloseModal = () => {
    setMode(null)
  }

  return (
    <>
      <BreadCrumb
        tree={[
          localize('accountsManagement'),
          localize('bankToBank'),
          localize('bankToBankRequestsCatalogue'),
        ]}
      />
      <div className="col-12">
        <div className="card bg-white">
          <div className="card-body">
            {isBusy ? (
              <Loader />
            ) : (
              <>
                <div className="row mb-2">
                  <div className="col-md-2">
                    <div className="mb-3">
                      <FIleSelectLookup
                        id={'bankToBankFileItem'}
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        displayValue={selectedBankToBankRequest?.fileName}
                        onSelect={async e => {
                          let file = e.target.files[0]
                          try {
                            let b64 = await toBase64(file)
                            let buffer = b64.split(',')[1].toString()
                            setSelectedBankToBankRequest({
                              ...selectedBankToBankRequest,
                              buffer,
                              fileName: file.name,
                              fileExtension: 'csv',
                            })
                          } catch {
                            Swal.fire(
                              'Invalid File',
                              'Error loading file',
                              'error'
                            )
                            return
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <button
                        onClick={() => {
                          if (!selectedBankToBankRequest?.fileName) {
                            Swal.fire(
                              'Oooops!',
                              'Please first select a file',
                              'info'
                            )
                            return
                          } else {
                            setMode('import')
                            handleSubmit()
                          }
                        }}
                        className="btn btn-success waves-effect waves-light text-capitalize"
                      >
                        <i className="mdi mdi-plus me-2"></i>
                        {localize('import')}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row mb-2 mx-0">
                  <RecordsPerPage
                    className="col-2"
                    reqParams={reqParams}
                    setReqParams={setReqParams}
                  />
                  <div className="col-2 d-flex align-items-center">
                    <label className="col-3  text-capitalize">
                      {localize('groupBy')}
                    </label>
                    <select
                      className="form-select text-capitalize"
                      defaultValue={groupBy.column}
                      style={{ maxWidth: 'fit-content' }}
                      onChange={e =>
                        setGroupBy({
                          label: groupingColumns.find(
                            f => f.column === e.target.value
                          )?.label,
                          column: e.target.value,
                        })
                      }
                    >
                      {groupingColumns.map(({ label, column }) => (
                        <option className="text-capitalize" value={column}>
                          {label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-3">
                    <div className="d-flex align-items-center">
                      <label className="text-capitalize" htmlFor="searchByDate">
                        {localize('dateRange')}
                      </label>
                      <DatePicker
                        onSelect={v => {
                          if (v.custom) {
                            setReqParams({
                              ...reqParams,
                              customDate: true,
                              startDate: v.startDate,
                              endDate: v.endDate,
                            })
                          } else {
                            setReqParams({
                              ...reqParams,
                              customDate: false,
                              dateRequestsFilter: v.value,
                            })
                          }
                        }}
                      />
                    </div>
                  </div>
                  <form
                    className="d-flex align-items-center col-5 col"
                    onSubmit={e => {
                      e.preventDefault()
                      setReqParams({
                        ...reqParams,
                        filterText: search,
                      })
                    }}
                  >
                    <label
                      className="ms-2 text-capitalize"
                      htmlFor="searchTable"
                    >
                      {localize('search')}
                    </label>
                    <EnumsServerCombo
                      className="ms-2"
                      customContainerStyle={{ width: '100%' }}
                      enumsKey="BankToBankRequestFilter"
                      value={reqParams?.bankToBankRequestFilter}
                      onChange={e =>
                        setReqParams({
                          ...reqParams,
                          bankToBankRequestFilter: e.value,
                        })
                      }
                    />
                    <input
                      type="search"
                      id="searchTable"
                      className="form-control"
                      defaultValue={reqParams.filterText}
                      onChange={e => {
                        setSearch(e.target.value)
                        setReqParams({
                          ...reqParams,
                          filterText: e.target.value,
                        })
                      }}
                    />
                    <button
                      id="bankToBankRequestFilterButton"
                      type="button"
                      className="btn btn-primary ms-2"
                      onClick={() => {
                        loadData()
                      }}
                    >
                      <i className="uil uil-filter"></i>
                    </button>
                  </form>
                </div>

                <GroupedTable
                  groupBy={groupBy}
                  columns={columns}
                  data={data?.pageCollection}
                  contextMenu={r => (
                    <>
                      <div
                        className="ctxt-menu-item"
                        onClick={() => {
                          setMode('view')
                          setSelectedBankToBankRequest(r)
                        }}
                      >
                        <i className="uil uil-edit-alt"></i>
                        {localize('view')}
                      </div>
                      <div
                        className="ctxt-menu-item"
                        onClick={() => {
                          setMode('reconcile')
                          setSelectedBankToBankRequest(r)
                        }}
                      >
                        <i className="uil uil-compress-lines"></i>
                        {localize('reconcile')}
                      </div>
                      <div
                        className="ctxt-menu-item text-capitalize"
                        onClick={() => {
                          handleViewAuditLogs(r)
                        }}
                      >
                        <i className="uil uil-server"></i>
                        <span>{localize('viewAuditLog')}</span>
                      </div>
                    </>
                  )}
                />
                <div className="mb-2"></div>
                <Pager
                  itemsCount={data?.itemsCount}
                  pageSize={reqParams.pageSize}
                  pageIndex={reqParams.pageIndex}
                  pageBatchSize={10}
                  onPageChange={p =>
                    setReqParams({ ...reqParams, pageIndex: p })
                  }
                />
              </>
            )}
          </div>
        </div>
      </div>
      {mode === 'auditLogs' && (
        <ViewAuditLogs
          handleClose={handleCloseModal}
          mode={mode}
          data={auditLogsDetails}
          title={auditLogsDetails?.description}
        />
      )}
      {mode === 'reconcile' ? (
        <ReconcileBankToBankDataModal
          selectedBankToBankRequest={selectedBankToBankRequest}
          setSelectedBankToBankRequest={setSelectedBankToBankRequest}
          mode={mode}
          onSetMode={m => {
            setMode(m)
          }}
          close={handleCloseModal}
          loadData={loadData}
        />
      ) : (
        mode === 'view' && (
          <ViewBankToBankDataModal
            selectedBankToBankRequest={selectedBankToBankRequest}
            mode={mode}
            close={handleCloseModal}
            entryStatus={1}
          />
        )
      )}
    </>
  )
}

export default Reconciliation
